import { Map } from 'immutable';
import { entitiesReducerInitializer } from '@mtblc/mtblc-redux';

const INITIAL_STATE = Map({});

export default entitiesReducerInitializer(INITIAL_STATE);

export const getEntities = state => state.entities;
